import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const Mp3FrameToDownload = (props: QRFRameToPrintProps): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 218.75 322.835938 C 218.75 311.332031 228.078125 302.007812 239.582031 302.007812 L 807.292969 302.007812 C 818.796875 302.007812 828.125 311.332031 828.125 322.835938 L 828.125 853.953125 C 828.125 865.457031 818.796875 874.78125 807.292969 874.78125 L 583.332031 874.78125 C 571.828125 874.78125 562.5 884.105469 562.5 895.609375 L 562.5 1135.132812 C 562.5 1146.640625 553.171875 1155.960938 541.667969 1155.960938 L 239.582031 1155.960938 C 228.078125 1155.960938 218.75 1146.640625 218.75 1135.132812 Z M 218.75 322.835938 "
        />
        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="240.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 843.75 880.085938 C 843.75 880.832031 843.675781 881.574219 843.535156 882.304688 C 843.390625 883.035156 843.175781 883.734375 842.890625 884.433594 C 842.617188 885.121094 842.261719 885.792969 841.847656 886.410156 C 841.644531 886.722656 841.417969 887.039062 841.171875 887.324219 C 840.929688 887.625 840.671875 887.910156 840.402344 888.183594 L 567.257812 1161.261719 C 566.441406 1162.074219 565.527344 1162.742188 564.554688 1163.261719 C 564.3125 1163.386719 564.066406 1163.523438 563.824219 1163.617188 C 563.050781 1163.96875 562.238281 1164.230469 561.40625 1164.386719 C 561.105469 1164.457031 560.792969 1164.5 560.476562 1164.53125 C 560.046875 1164.59375 559.605469 1164.613281 559.160156 1164.613281 C 557.6875 1164.613281 556.210938 1164.332031 554.78125 1163.75 C 550.503906 1161.96875 547.730469 1157.792969 547.730469 1153.171875 L 547.730469 1141.734375 L 554.425781 1141.734375 L 559.175781 1136.988281 L 559.175781 1153.171875 L 832.316406 880.101562 L 816.121094 880.101562 L 820.855469 875.367188 L 820.855469 868.65625 L 832.316406 868.65625 C 836.9375 868.65625 841.117188 871.445312 842.890625 875.722656 C 843.476562 877.140625 843.75 878.613281 843.75 880.085938 Z M 843.75 880.085938 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 843.75 301.441406 L 843.75 880.085938 C 843.75 878.613281 843.476562 877.140625 842.890625 875.722656 C 841.117188 871.445312 836.9375 868.65625 832.316406 868.65625 L 820.855469 868.65625 L 820.859375 312.882812 L 229.191406 312.882812 L 229.191406 818.878906 L 206.300781 818.878906 L 206.300781 301.441406 C 206.300781 295.132812 211.421875 289.996094 217.746094 289.996094 L 832.304688 289.996094 C 838.628906 289.996094 843.75 295.132812 843.75 301.441406 Z M 843.75 301.441406 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 843.535156 882.304688 C 843.390625 883.035156 843.175781 883.734375 842.890625 884.433594 C 843.175781 883.75 843.390625 883.035156 843.535156 882.304688 Z M 843.535156 882.304688 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 841.847656 886.410156 C 841.644531 886.722656 841.417969 887.039062 841.171875 887.324219 C 841.429688 887.039062 841.644531 886.722656 841.847656 886.410156 Z M 841.847656 886.410156 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 832.316406 880.101562 L 559.175781 1153.171875 L 559.175781 1136.988281 L 570.621094 1125.542969 L 804.675781 891.542969 L 816.121094 880.101562 Z M 832.316406 880.101562 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 820.855469 868.65625 L 820.855469 875.367188 L 816.121094 880.101562 L 559.175781 880.101562 L 559.175781 1136.988281 L 554.425781 1141.734375 L 547.730469 1141.734375 L 547.730469 880.101562 C 547.730469 873.78125 552.851562 868.65625 559.175781 868.65625 Z M 820.855469 868.65625 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 816.121094 880.101562 L 804.675781 891.542969 L 570.621094 891.542969 L 570.621094 1125.542969 L 559.175781 1136.988281 L 559.175781 880.101562 Z M 816.121094 880.101562 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 554.78125 1163.75 C 556.210938 1164.332031 557.6875 1164.613281 559.160156 1164.613281 L 217.746094 1164.613281 C 211.421875 1164.613281 206.300781 1159.480469 206.300781 1153.171875 L 206.300781 1007.691406 L 229.191406 1007.691406 L 229.191406 1141.734375 L 547.730469 1141.734375 L 547.730469 1153.171875 C 547.730469 1157.792969 550.503906 1161.96875 554.78125 1163.75 Z M 554.78125 1163.75 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 389.890625 911.683594 C 394.570312 906.878906 397.042969 900.285156 397.042969 891.917969 C 397.042969 883.664062 394.011719 876.941406 388.929688 872.550781 C 383.433594 867.601562 374.78125 864.855469 362.976562 864.855469 C 353.347656 864.855469 345.796875 865.683594 340.027344 866.640625 L 340.027344 958.101562 L 351.976562 958.101562 L 351.976562 921.023438 C 354.738281 921.710938 358.027344 921.855469 361.605469 921.855469 C 373.277344 921.855469 383.582031 918.421875 389.890625 911.683594 Z M 464.203125 932.839844 C 464.203125 920.339844 455.273438 912.097656 444.289062 909.894531 L 444.289062 909.625 C 455.273438 905.648438 460.769531 897.808594 460.769531 888.613281 C 460.769531 877.769531 452.800781 867.328125 435.214844 867.328125 C 425.601562 867.328125 416.542969 870.761719 411.867188 874.195312 L 415.027344 882.992188 C 418.875 880.230469 425.730469 877.082031 432.882812 877.082031 C 444 877.082031 448.535156 883.390625 448.535156 890.542969 C 448.535156 901.113281 437.417969 905.648438 428.617188 905.648438 L 421.894531 905.648438 L 421.894531 914.703125 L 428.617188 914.703125 C 440.292969 914.703125 451.570312 920.066406 451.699219 932.554688 C 451.839844 939.976562 447.035156 949.863281 431.507812 949.863281 C 423.125 949.863281 415.15625 946.429688 411.722656 944.226562 L 408.433594 953.566406 C 412.824219 956.457031 421.625 959.617188 431.640625 959.617188 C 453.070312 959.617188 464.203125 947.117188 464.203125 932.839844 Z M 512.992188 830.324219 L 512.992188 996.25 L 229.191406 996.25 L 229.191406 958.101562 L 238.53125 958.101562 L 241.007812 918.421875 C 241.839844 904.546875 242.507812 889.027344 242.792969 877.484375 L 243.066406 877.484375 C 245.671875 888.484375 249.378906 900.429688 253.785156 913.472656 L 268.75 957.558594 L 277.820312 957.558594 L 294.160156 912.644531 C 298.835938 899.871094 302.6875 888.339844 305.832031 877.484375 L 306.25 877.484375 C 306.121094 889.027344 306.9375 904.546875 307.621094 917.449219 L 309.953125 958.101562 L 321.628906 958.101562 L 315.863281 865.539062 L 300.625 865.539062 L 284.144531 910.3125 C 280.007812 921.984375 276.714844 932.152344 274.386719 941.480469 L 273.972656 941.480469 C 271.640625 931.867188 268.476562 921.710938 264.628906 910.3125 L 248.832031 865.539062 L 233.582031 865.539062 L 229.191406 928.550781 L 229.191406 830.324219 Z M 512.992188 830.324219 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 363.25 874.335938 C 376.425781 874.335938 385.082031 880.230469 385.082031 892.460938 C 385.082031 905.234375 376.296875 912.242188 361.875 912.242188 C 357.882812 912.242188 354.59375 911.957031 351.976562 911.269531 L 351.976562 875.296875 C 354.050781 874.738281 358.027344 874.335938 363.25 874.335938 Z M 363.25 874.335938 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 229.191406 958.101562 L 229.191406 996.25 L 206.300781 996.25 L 206.300781 830.324219 L 229.191406 830.324219 L 229.191406 928.550781 L 227.128906 958.101562 Z M 229.191406 958.101562 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 206.300781 830.324219 L 206.300781 996.25 L 156.25 996.25 L 156.25 830.324219 Z M 206.300781 830.324219 "
        />
      </g>
    </svg>
  );
};
